import React from 'react'
import { Field } from '@ztechapps/webui.form'
import { InlineDisplayContent, TagsInput, TextAreaInput } from '@ztechapps/webui.input'
import { QuantityInputWithUom } from '@ztechapps/product.webui'
import { Stack } from 'react-bootstrap'
import type { ProductQuantityProps } from '@ztechapps/webui.contract'
import { WebuiIocKey, useInjectComponent } from '@ztechapps/webui.contract'
import { useCreateAndBuildContext } from './Context'

export const QtyForm = () => {
  const { product, setQtyToBuild } = useCreateAndBuildContext()
  const ProductQuantity = useInjectComponent<ProductQuantityProps>(WebuiIocKey.product.productQuantity)

  const onQuantityChange = (e) => {
    const quantity = Number(e.target.value)
    setQtyToBuild(quantity)
  }

  return (
    <Stack gap={1}>
      <div>
        <Field
          name="quantity"
          min={1}
          component={QuantityInputWithUom}
          symbol={product?.baseUom?.symbol ?? ''}
          label="Quantity"
          help="The quantity to be manufactured."
          onChange={onQuantityChange}
        />
      </div>
      <div>
        <Field
          name="remarks"
          component={TextAreaInput}
          label="Remarks"
          help="Set a remarks about this adjustment, it will remind you in the future the reason for your changes."
        />
      </div>
      <div>
        <Field
          name="tags"
          component={TagsInput}
          label="Tags"
          help="Setting the tags to categorized this changes."
          onChange
        />
      </div>

      <div>
        <InlineDisplayContent label="Inventory Count" meta={{ touched: true }}>
          <ProductQuantity
            hasSubComponents={product?.hasSubComponents}
            quantityOnHand={product?.inventory?.quantityOnHand}
            requiredComputedQuantityOnHand={product?.requiredComputedQuantityOnHand}
            computedQuantityOnHand={product?.computedQuantityOnHand}
            baseUomSymbol={product?.baseUom?.symbol}
            decimalPrecision={product?.unitOfMeasurePrecision}
          />
        </InlineDisplayContent>
      </div>
    </Stack>
  )
}
